import { Timestamp } from "../../../types/firebase.types";
import { GenericFunction, WeekDay } from "../../../types/generic.types";

export interface CourtSlot {
  startTime: Date;
  reserved: boolean;
  courtAvailabilityRangeId: string;
  time: number;
}

export interface IAvailabilitiesRanges {
  id: string;
  color: string;
  append: boolean;
  overwrite: boolean;
  startDate: Date;
  endDate: Date;
  saturday: WeekDay.saturday;
  sunday: WeekDay.sunday;
  monday: WeekDay.monday;
  tuesday: WeekDay.tuesday;
  wednesday: WeekDay.wednesday;
  thursday: WeekDay.thursday;
  friday: WeekDay.friday;
  createdAt: Timestamp;
  updatedAt: Timestamp;
}

export interface ICourt {
  [key: string]: any;
}

export interface ICalendarContext {
  courtId: string;
}

export interface ICellContext {
  selectedCellDate: Date | undefined;
  minSlot: number | undefined;
  closeModal: GenericFunction;
}

export interface IRangeRef {
  startDate: Date | undefined;
  endDate: Date | undefined;
}

export enum CellManageMode {
  create = "create",
  overwrite = "overwrite",
}

export enum SetRangeType {
  creation = "creation",
  edit = "edit",
}

export type SlotsMap = Map<string, Set<number>>;
